var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-station"},[_c('headline',[_vm._v(" "+_vm._s(_vm.$tc('statistic',2))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }